import authPlugin from './authPlugin'

export default [authPlugin]
